module.exports = __webpack_public_path__ + "LatoLatin-Thin.c65fe92919208091f3c3.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Thin.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Thin.woff
// module chunks = styles